import { NgIf } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AiIllustrationComponent } from '../../../../shared/components/ai-illustration/ai-illustration.component';

// Short welcome splash shown in the middle of the screen each time the AI settings page opens.
// Closes by itself; a click or Escape skips it.
@Component({
  imports: [AiIllustrationComponent, NgIf, TranslateModule],
  selector: 'app-ai-welcome',
  standalone: true,
  styleUrl: './ai-welcome.component.scss',
  templateUrl: './ai-welcome.component.html',
})
export class AiWelcomeComponent implements OnInit, OnDestroy {
  public readonly displayDurationMs = 2200;
  public readonly isVisible = signal(true);

  private hideTimeoutId?: ReturnType<typeof setTimeout>;

  public ngOnInit(): void {
    this.hideTimeoutId = setTimeout(() => this.dismiss(), this.displayDurationMs);
  }

  @HostListener('document:keydown.escape')
  public dismiss(): void {
    clearTimeout(this.hideTimeoutId);
    this.isVisible.set(false);
  }

  public ngOnDestroy(): void {
    clearTimeout(this.hideTimeoutId);
  }
}
